import firebase from "../firebase";

export default function({ officeId, userIds }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "messagingUser",
        funcName: "createConversation",
        data: { officeId, userIds }
    });
}
